@let entities = entitiesSg();
@let value = valueSg();

<div class="atn-multi-reference">
  @for (entity of entities; track $index) {
    <atn-ds-select-multiple
      [config]="{
        overlay: {
          minSearchCharacters: 1,
          entityName: 'Record',
          hasSearch: true,
        },
      }"
      [label]="entity.name"
      [value]="value?.[entity.id] ?? []"
      (valueChange)="valueChangeHandler({ entity, recordIds: $event })"
      [items]="getRecordsFor({ entity }).asSignal()"
      [error]="displayFeature.selectors.getError({ entity }).asSignal()"
      [loading]="displayFeature.selectors.isLoading({ entity }).asSignal()"
      (refetch)="refetchRecordItemsClickHandler({ entity })"
    />
  }
</div>
